import { IApiResponse } from "../../../@types/api-response.type";
import { ICreateTenant } from "../../../@types/create-tenant.type";
import { ITenant } from "../../../@types/tenant.type";
import { Api } from "../ApiConfig";

export const getAllTenantsByAccount = async (email: string): Promise<ITenant[]> => {
    const response = await Api.get<IApiResponse<ITenant[]>>(`/api/Tenant/GetAllTenantsByAccount?email=${email}`);
    return response.data.result;
}

export const createTenant = async (createTenant: ICreateTenant): Promise<void> => {
    await Api.post(`/api/Tenant/AddTenant`, createTenant);
}

export const verifyIfTenantExists = async (tenantName: string): Promise<boolean> => {
    const response = await Api.get<IApiResponse<string>>(`/api/Tenant/VerifyIfTenantExists?tenantName=${tenantName}`);
    return JSON.parse(response.data.result);
}